<script>
export default {
  name: "DidoExploreTypeFilter",
};
</script>

<script setup>
import { ref } from "vue";

// define Props
const props = defineProps({
  type: { type: String, required: true },
});

// Define Emits
const emit = defineEmits(["new-type"]);

// define Reactive data
const typeTab = ref(props.type);
</script>

<template>
  <QTabs
    v-model="typeTab"
    no-caps
    align="left"
    narrow-indicator
    dense
    active-bg-color="white"
    active-color="secondary"
    indicator-color="secondary"
    @update:model-value="emit('new-type', typeTab)"
  >
    <QTab name="dataset" label="Jeux de données" />
    <QTab name="datafile" label="Fichiers de données" />
  </QTabs>
</template>
